<mpro-modal *ngIf="true" title="Get in touch to get full access to World Data Pro"
    [open]="(upsaleModalService.modalStateObs | async) || false" (openChange)="onModalClose()">
    <div class="custom-modal-body">
        <mpro-loading *ngIf="loading"></mpro-loading>
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="row">
                <div class="col-6">
                    <mpro-text-input placeholder="First Name" formControlName="firstName">
                    </mpro-text-input>
                </div>
                <div class="col-6">
                    <mpro-text-input placeholder="Last Name" formControlName="lastName">
                    </mpro-text-input>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <mpro-text-input placeholder="Company Name" formControlName="organizationName">
                    </mpro-text-input>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <mpro-text-input placeholder="Email" formControlName="userEmail">
                    </mpro-text-input>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <textarea placeholder="Message" formControlName="userText"></textarea>
                </div>
            </div>
            <div class="footer">
                <button class="mpro-btn mpro-btn-primary" type="submit" [disabled]="!form.valid || loading">submit</button>
            </div>
        </form>
    </div>
</mpro-modal>